exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tile-stats{\r\n    cursor: pointer;\r\n}\r\n\r\n.profiledata{\r\n    margin-top: 10px;\r\n}\r\n\r\n.deletebtn{\r\n    color: red;\r\n}\r\n\r\n.gapbtn{\r\n    margin-top: 25px;\r\n}\r\n\r\n.distanceinput{\r\n    margin-top: 15px;\r\n}\r\n\r\n.mousehoverinfo{\r\n    cursor: pointer;\r\n}\r\n\r\n.profile-picture{\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/my-profile/my-profile.component.css
// module id = ../../../../../src/app/components/my-profile/my-profile.component.css
// module chunks = 0